import { combineReducers } from 'redux';
import { readMessageReducer } from './message/reducers';
import { readNotificationReducer } from './notification/reducers';
import authReducer from './authentication/reducers';
import ChangeLayoutMode from './themeLayout/reducers';
import { userReducer } from './users/reducers';
import { headerSearchReducer } from './headerSearch/reducers';
import { editReducer, expoReducer, indexReducer, chatReducer, reDirReducer } from './CrmReduxCalls/EditNavCtrl';
import { apiEmailReducer } from './CrmReduxCalls/EmailConfigCheck';
import { apiCalendarReducer } from './CrmReduxCalls/CalendarResponse';
import { apiCallingReducer } from './CrmReduxCalls/ProductInteApiCalls';
import { localdataReducer } from './CrmReduxCalls/LocalDataReduxStore';
import { aiDataReducer } from './CrmReduxCalls/AiResearch';
import { chatCurrentViewReducer } from './CrmReduxCalls/ChatCurrentView';

const rootReducers = combineReducers({
  headerSearchData: headerSearchReducer,
  message: readMessageReducer,
  notification: readNotificationReducer,
  users: userReducer,
  auth: authReducer,
  ChangeLayoutMode,
  edit: editReducer,
  EmailData: apiEmailReducer,
  CalendarRData: apiCalendarReducer,
  callingRedux: apiCallingReducer,
  localRedux: localdataReducer,
  aiRedux: aiDataReducer,
  explosion: expoReducer,
  indexRedux: indexReducer,
  chatRedux: chatReducer,
  reDirRedux: reDirReducer,
  chatCurrentViewRedux: chatCurrentViewReducer,
});

export default rootReducers;